/* Rejoue les appels jQuery mis en file d'attente par le relais de theme.liquid (jQuery différé). */
(function () {
  var $ = window.jQuery;
  if (!$ || !$.fn || !$.fn.jquery) return;
  var q = window.__jqQueue || [];
  window.__jqQueue = null;
  q.forEach(function (c) {
    try {
      var name = c[0], t = c[1], args = c[2];
      if (name === 'ready') { $(args[0]); return; }
      var o = $(t);
      if (typeof o[name] === 'function') o[name].apply(o, args);
    } catch (e) { if (window.console) console.error('jq-replay', e); }
  });
})();
